import { render, staticRenderFns } from "./serviceAdd.vue?vue&type=template&id=51ef949a&"
import script from "./serviceAdd.vue?vue&type=script&lang=js&"
export * from "./serviceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports